<template>
	<div class="vx-row" v-if="visitPointDetail">
		<div class="vx-col w-full">
			<transition name="slide-fade">
				<vx-card class="overflow-hidden" no-shadow>
					<div slot="no-body">
						<table style="width: 100%" class="border-collapse">
							<caption></caption>
							<tr>
								<th class="p-2 border border-solid d-theme-border-grey-light font-bold text-lg">
									{{ $t("Information") }}
								</th>
								<th class="p-2 border border-solid d-theme-border-grey-light font-bold text-lg">
									{{ $t("UploadFiles.Details") }}
								</th>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("Routing.Table.Identification") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ visitPointDetail.identification }}
								</td>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("Deposits.Form.Longitude") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ visitPointDetail.latitude }}
								</td>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("Deposits.Form.Latitude") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ visitPointDetail.longitude }}
								</td>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("Routing.Table.TimeService") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ visitPointDetail.time_service ? visitPointDetail.time_service : "00:00:00" }}
								</td>
							</tr>
						</table>
					</div>
				</vx-card>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	name: "DetailVisitPointShipment",
	props: {
		visitPointDetail: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
